<template>
  <div class="form-horizontal flex-column upload-file-form">
    <div class="flex-row flex-wrap justify-content-center text-center">
      <el-upload class="upload-demo" drag action="" :auto-upload="false" :on-change='onFileChange' ref='upload' multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将表格文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">支持xls不超过10M</div>
      </el-upload>
    </div>
    <div class="flex-row flex-wrap justify-content-between">
      <div class="p-t-sm download-link">
        <a :href="downloadUrl" download='' class="download-txt">下载表格模板</a>
      </div>
      <div class="form-group p-t-sm">
        <div class="text-right">
          <!-- <button class="btn btn-primary" type="button" @click="submitUpload">确定</button> -->
          <el-button class="primary-btn-g" icon="CircleCheck" @click="submitUpload">确定</el-button>
          <!-- <button class="btn btn-white" data-dismiss="modal">取消</button> -->
          <el-button class="warning-btn-g" icon="CircleClose" data-dismiss="modal">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {

  data() {
    return {
      areUOk: false,
    }
  },
  props: {
    modalShow: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    modalShow(to) {
      if (!to) return
      this.$refs.upload.clearFiles()
    },
  },
  methods: {
    ...mapActions([
      'importUpload',
      'alertToggle'
    ]),
    onFileChange(file, fileList) {
      let tailType = file.name.slice(file.name.lastIndexOf('.') + 1)
      let isType = ['xls'].indexOf(tailType) > -1
      let isSize = file.size / 1000 /1024 < 10
      if (!isType) {
        this.$refs.upload.clearFiles();
        this.alertToggle({
          alertType: 'danger',
          alertContent: '只能上传xls文件!'
        })
        return false
      }
      if (!isSize) {
        this.$refs.upload.clearFiles();
        this.alertToggle({
          alertType: 'danger',
          alertContent: '文件超过10MB'
        })
        return false
      }
      this.areUOk = true
      this.uploadParams = {
        file: file.raw,
        id: 'fileToUpload'
      }
    },
    submitUpload() {
      if (!this.areUOk) {
        this.alertToggle({
          alertType: 'danger',
          alertContent: '请先上传文件！'
        })
        return
      }
      this.$emit('submitUpload', this.uploadParams)
    },
  }
}
</script>
<style lang="less" scoped>
  .download-link a{
    color: @font-color-theme;
  }
</style>
